import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ThankYou() {
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 800, mx: "auto", mt: 10, p: 3 }}>
      <Paper elevation={3} sx={{ p: 5, textAlign: "center", borderRadius: 3 }}>
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          🎉 Благодарим за поръчката!
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Вашата поръчка е успешно изпратена. Ще се свържем с Вас възможно най-скоро за потвърждение.
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate("/")}
            sx={{ px: 4, py: 1.5 }}
          >
            Продължи към магазина
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
